@import './pk-card.variables';

@layer components {
  .sponsor-common {
    @apply pointer-events-none absolute top-0 z-[1] mt-[calc(var(--card--aspect-ratio)-4px)] block content-[''];
  }
}

:host {
  @apply relative block h-full w-full;
}

:host(.has-sponsor) {
  .sponsor-image {
    @apply sponsor-common z-[2] flex items-center justify-center;

    .pk-image {
      @apply h-[--card--sponsor-height] w-[--card--sponsor-width];
    }
  }
}

:host(.has-sponsor.sponsor-default) {
  .card--heading__outline:not(.horizontal) {
    &::before {
      @apply sponsor-common h-[4px] w-full bg-[color:--card--sponsor-strip-color];
    }
  }

  .sponsor-image {
    @apply mt-[calc(var(--card--aspect-ratio)-var(--card--sponsor-container-height)*0.5-2px)] h-[--card--sponsor-container-height] w-full;
  }
}

:host(.has-sponsor.sponsor-top-left) {
  .card--heading__outline {
    &::before {
      @apply sponsor-common mt-0 h-[4px] w-full bg-[color:--card--sponsor-strip-color];
    }

    .sponsor-image {
      @apply left-0 ml-s mt-s;
    }
  }
}

:host(.has-sponsor.sponsor-top-right) {
  .card--heading__outline {
    &::before {
      @apply absolute bottom-auto left-auto right-0 top-0 z-[1] h-[96px] w-[96px] content-[''];

      background: linear-gradient(221.11deg, var(--card--sponsor-strip-color) 0%, rgba(28, 136, 235, 0) 47.03%);
      clip-path: polygon(100% 0, 0 0, 100% 100%);
    }

    .sponsor-image {
      @apply left-[unset] right-0 mr-s mt-s;
    }
  }
}

.card--wrapper {
  @apply relative box-border flex h-[--card--height] w-full overflow-hidden bg-[color:--card--background-color];
  @apply rounded-[--card--border-radius] border-[length:--card--border-width] border-[color:--card--border-color];
  @apply transition-[box-shadow_border] duration-250;

  &.horizontal {
    @apply flex-row;
  }

  &.portrait {
    @apply flex-col;
  }

  &.with-elevation {
    box-shadow: var(--card--box-shadow);
  }

  &.no-body {
    .card--heading__outline {
      @apply h-full rounded-[--card--border-radius];
    }

    .card--body__outline {
      @apply p-0;
    }
  }

  &.has-transparency:not(.with-elevation) {
    @apply border-none bg-transparent #{!important};
  }
}

.card--heading__outline {
  @apply relative rounded-b-none rounded-t-[--card--border-radius] bg-transparent;

  &::after {
    @apply block pt-[--card--aspect-ratio] content-[''];
  }

  &.content-over {
    @apply h-full rounded-[--card--border-radius];
  }

  &.horizontal {
    @apply w-full rounded-bl-[--card--border-radius] rounded-br-[0] rounded-tl-[--card--border-radius] rounded-tr-[0];
  }

  &.has-transparency:not(.with-elevation) {
    @apply overflow-hidden rounded-[--card--border-radius];
  }

  ::slotted(div) {
    @apply absolute left-0 top-0 h-full w-full;
  }
}

.hidden {
  @include hidden;
}

.card--heading__content {
  @apply absolute left-0 top-0 h-full w-full rounded-b-[0] rounded-t-[--card--border-radius];
}

.card--body__outline {
  @apply relative box-border flex w-full rounded-b-[--card--border-radius] rounded-t-[0] p-[--card-body--padding];

  font-family: var(--card--font-family);

  &.content-over {
    @apply absolute bottom-[2px] left-0;

    &::before {
      @apply absolute bottom-[-2px] left-0 right-0 h-[130%] rounded-b-[--card--border-radius] rounded-t-[0] content-[''];

      background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
    }

    ::slotted(div) {
      @apply z-[1];
    }
  }
}
